import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  CircularProgress,
  MenuItem,
  Select,
  Alert
} from "@mui/material"
import GridFiles from "components/Common/GridFilesAnt"
import FilePondUpload from "components/Common/FilePondUpload"
import { getCurrentUser, enumToArray } from "helpers/service_helper"
import { UserFileType } from "models/types/user-file-type"
import GridUserFiles from "components/Common/GridUserFiles"
import { Modal } from "antd"

export const UserFiles = ({ rowData, mainProps }) => {
  const { lstUserFiles } = mainProps
  const style = {
    // border: "2px solid #000",
    p: 2,
  }
  const [files, setFiles] = useState([])
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
        title:mainProps.t("enums." + UserFileType[2]),
      fileTypeEnum: 2
    }
  )
  const [open, setOpen] = useState(false)
  const [userFileTypes, setUserFileTypes] = useState([])
  useEffect(() => {
    setUserFileTypes(enumToArray(UserFileType))
  }, [])

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
  }
  const saveToDatabase = async values => {
    const { onAddUserFile } = mainProps
    let file = files[0].file
    const fileName = UserFileType[values.fileTypeEnum]
    let formData = new FormData()
    formData.append(
      "file",
      file,
      fileName +
      "-" +
      file.name.substr(0, file.name.lastIndexOf(".")) +
      "." +
      file.name.split(".")[file.name.split(".").length - 1]
    )
    formData.append("name", fileName)
    formData.append("title", values.title)
    formData.append("des", `Upload with-${rowData.userId}`)
    formData.append("userFileTypeEnum", fileName)
    formData.append("FolderName", "UserFiles")
    formData.append(
      "FileName",
      fileName +
        // "-" +
        // file.name.substr(0, file.name.lastIndexOf(".")) +
         "." +
         file.name.split(".")[file.name.split(".").length - 1]
    )
    formData.append("userId", rowData.userId)
    formData.append("toUserId", rowData.userId)
    await onAddUserFile(formData)
  }
  const handleSubmitForm = async (event, values) => {
    event.preventDefault()

    if (files[0]) {
    await saveToDatabase(formInput)
    // await onGetUserFiles(formInput.idGasProject)
    }else {
      setErrorMessage("برای ذخیره ابتدا فایل را برگذاری کنید")
    }
  }
  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{}}
        onClick={async () => {
          const { onGetUserFiles } = mainProps

          await onGetUserFiles(rowData.userId)

          setOpen(!open)
        }}
      >
        فایلها
      </Button>

      <Modal
        open={open}
        title={"مدیریت فایل های پرونده:" + rowData.fullName}
        onCancel={() => setOpen(false)}
        onClose={() => {
          setOpen(false)
        }}
        footer={null}
        width={700}
      >
        <form onSubmit={handleSubmitForm}>
          <DialogContent>
            <Grid item xs={12}>
                {mainProps.errorUser ? (
                  <Alert severity="error">{mainProps.errorUser}</Alert>
                ) : null}
                {mainProps.successUser ? (
                  <Alert severity="success">{mainProps.successUser}</Alert>
                ) : null}
              </Grid>
            <Box sx={{ ...style }}>
              <GridUserFiles lstUserFiles={lstUserFiles} props={mainProps} />
            </Box>
           <Box>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                <FormControl size="small" fullWidth>
                    <InputLabel id="select-label-fileTypeEnum">
                      نوع فایل
                    </InputLabel>
                    <Select
                      labelId="select-label-fileTypeEnum"
                      name="fileTypeEnum"
                      value={
                        formInput.fileTypeEnum ? formInput.fileTypeEnum : 2
                      }
                      label="نوع فایل"
                      onChange={handleInput}
                    >
                      {userFileTypes && lstUserFiles &&
                        userFileTypes.map(row => {
                          if (row.id !== 0 && !lstUserFiles.find(x=>x.fileTypeName == row.name)) {
                            return (
                              <MenuItem key={row.id} value={row.id}>
                                {mainProps.t("enums." + row.name)}
                              </MenuItem>
                            )
                          }
                        })}
                    </Select>
                  </FormControl>
                </Grid>
                
                <Grid item xs={12}>
                <FilePondUpload
                  setFiles={setFiles}
                  maxFileSize="800KB"
                  allowMultiple={false}
                  maxFiles={1}
                  acceptedFileTypes={["image/png", "image/jpeg"]}
                  imagePreviewMaxHeight={600}
                  labelText={`${mainProps.t("enums." + UserFileType[formInput.fileTypeEnum])} را اینجا بکشید`}
                  waterMark={false}
                />
              </Grid>
                
              </Grid>
            </Box>
          </DialogContent>

          <DialogActions>
            <Box sx={{ display: "flex" }}>
              {mainProps.loading ? (
                <CircularProgress disableShrink />
              ) : (
                <Button  variant="contained" type="submit">
                  ذخیره
                </Button>
              )}
            </Box>
          </DialogActions>
        </form>
      </Modal>
    </Box>
  )
}
